/**
 * Generated by orval v7.7.0 🍺
 * Do not edit manually.
 * Backpac API
 * The Backpac API description
 * OpenAPI spec version: 1.0
 */

export type CampaignCampaignStatus = typeof CampaignCampaignStatus[keyof typeof CampaignCampaignStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignCampaignStatus = {
  UPCOMING: 'UPCOMING',
  SIGN_UP: 'SIGN_UP',
  CLOSED: 'CLOSED',
  EARLY_CLOSED: 'EARLY_CLOSED',
} as const;
